import quicklink from 'quicklink/dist/quicklink.umd';

$(document).ready(function(){
    quicklink.listen({
        ignores: [
            uri => uri.includes('wp-admin'),
        ],
    });
});
